import { format } from "date-fns";
import { MenuItemBase } from "../../components/layout/navMenu";

export const hasRole = (role: string | undefined, allowed: readonly string[]) =>
  !!role && allowed.includes(role);

export const hasShortcut = (shortcuts: MenuItemBase[], path: string) =>
  shortcuts.some((item) => item.path === path);

export const formatShortDate = (value?: string | null) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return format(date, "MMM d");
};

export const formatUsd = (amount: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(amount);
